<template>
  <div id="app">
    <Login v-if="!isLoggedIn" />
    <Main v-if="isLoggedIn"/>

    <TopWarning v-if="globalErr" :message="globalErr"/>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Login from "./components/Login";
import Main from "./components/Main.vue";
import TopWarning from "./components/TopWarning.vue";

export default {
  name: "app",
  components: {
    Login,
    Main,
    TopWarning
  },
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.isLoggedIn,
      globalErr: state => state.globalErr
    })
  },
  mounted () {
    // this.$cookies.set("token", "GH1.1.1689020474.1484362313");
    if (this.$cookies.get("cv_lk")) {
      console.log(this.$cookies.get("cv_lk"))
      this.$store.commit('setLogin', true)
    } else {
      console.log(this.$cookies.get("cv_lk"))
    }
  }
};
</script>

<style lang="scss">
  @import './var';

  #app {
    font-family: Arial, 'Roboto' sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-height: 100vh;
  }

</style>
